import * as $http from 'axios'

export default {
    create: payload => $http.post('v2/mileages', payload),
    checkLimit: params => $http.get('v2/mileages/check_limit', { params }),
    exchangePoint: params => $http.put('v2/mileages/exchange_point', params),
}
